export default __webpack_public_path__ + "static/media/bebejunto.ace9b678.mp4";